import ReactRailsUJS from 'react_ujs';
import '@styles/main';

const frontendContext = require.context('../features', true);
ReactRailsUJS.useContext(frontendContext);
